
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5A18u", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gdv5Z = parcelRequire("gdv5Z");


var $1qfLF = parcelRequire("1qfLF");


var $inPa6 = parcelRequire("inPa6");


var $8tSmd = parcelRequire("8tSmd");


var $5izcQ = parcelRequire("5izcQ");


var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");


var $dh538 = parcelRequire("dh538");


var $3gadb = parcelRequire("3gadb");


var $ep3mz = parcelRequire("ep3mz");


var $lfBMY = parcelRequire("lfBMY");


var $2wo33 = parcelRequire("2wo33");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $5qLRP = parcelRequire("5qLRP");


var $3l7KO = parcelRequire("3l7KO");

const $81250fe78e2ca6ba$export$6f9393ad41fd3010 = ()=>{
    const { isElementVisible: isElementVisible } = (0, $5qLRP.useElementVisibility)();
    const { data: data } = (0, $3l7KO.useContentLabels)();
    const { hasEditPermissions: hasEditPermissions } = data;
    return {
        isLabelsAvailable: isElementVisible((0, $5qLRP.ELEMENTS).ROWS.LABELS),
        canEditLabels: hasEditPermissions
    };
};



var $dYU3e = parcelRequire("dYU3e");


var $iCs0a = parcelRequire("iCs0a");

const $de869bbdf5f00a36$export$5de54ae30873d38d = async ({ contentId: contentId, canUpdateContent: canUpdateContent })=>{
    if (!contentId || !canUpdateContent) return;
    return (0, $dYU3e.query)({
        query: (0, $iCs0a.default),
        variables: {
            contentId: contentId
        },
        errorPolicy: 'all'
    });
};



var $hysf6 = parcelRequire("hysf6");


var $aWwYt = parcelRequire("aWwYt");


var $8aF6s = parcelRequire("8aF6s");


var $4vaoM = parcelRequire("4vaoM");


var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");


var $dPJCf = parcelRequire("dPJCf");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $1ggpj = parcelRequire("1ggpj");


var $8uM2K = parcelRequire("8uM2K");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");


var $aSsfA = parcelRequire("aSsfA");


var $6mKj3 = parcelRequire("6mKj3");


var $7aRa9 = parcelRequire("7aRa9");


var $3u7PM = parcelRequire("3u7PM");


var $4ZXww = parcelRequire("4ZXww");

const $5b43ab3c4bf50adc$var$i18n = (0, $aXWIB.defineMessages)({
    openDetailsPanelLabel: {
        id: "object-sidebar-components.open.details.panel.label",
        defaultMessage: "Open Details Panel"
    },
    showDetailsLabel: {
        id: "object-sidebar-components.show.details.label",
        defaultMessage: "Show details"
    }
});
const $5b43ab3c4bf50adc$export$12d2a34da9cda7d = (0, $7aRa9.withFlags)(({ contentId: contentId, collapsed: collapsed, isDisabled: isDisabled = false, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { showDetailsPanel: showDetailsPanel } = (0, $hysf6.useShowDetailsPanel)();
    const [contentTypeFromState] = (0, $ep3mz.useContentType)();
    // keyboard events do not bubble up to confluence when focus is in the iframe.
    // Since the keyboard shortcut does not work, we must hide the shortcut text.
    const isShortcutTextShown = contentTypeFromState !== (0, $1ggpj.ContentType).DATABASE;
    const panel = (0, $aWwYt.usePanel)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const [spaceKey = ''] = (0, $ep3mz.usePageSpaceKey)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { isLabelsAvailable: isLabelsAvailable, canEditLabels: canEditLabels } = (0, $81250fe78e2ca6ba$export$6f9393ad41fd3010)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { showNoEditAccessFlag: showNoEditAccessFlag } = (0, $3u7PM.useNoEditAccessFlag)(flags);
    const openDetailsPanelShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.UNIVERSAL_OPEN_DETAILS_PANEL_SHORTCUT)
    });
    const canUpdateContent = (0, $2wo33.useCanPerformContentOperation)({
        contentId: contentId ?? '',
        contentType: contentTypeFromState,
        operation: (0, $lfBMY.OperationTypes).UPDATE
    });
    const handleClickDetailsButton = (0, $42omo.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.SIDEBAR_DETAILS_PANEL_LOAD_EXPERIENCE)
        });
        showDetailsPanel();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'detailsPanel',
                source: 'contentWrapper',
                attributes: {
                    contentType: contentTypeFromState,
                    pageMode: pageMode
                }
            }
        }).fire();
    }, [
        showDetailsPanel,
        createAnalyticsEvent,
        experienceTracker,
        contentTypeFromState,
        pageMode
    ]);
    // Avoids CLS from redactions feature entitlement query in DetailsPanel
    const onHoverDetailsButton = (0, $42omo.useCallback)(()=>{
        (0, $de869bbdf5f00a36$export$5de54ae30873d38d)({
            contentId: contentId,
            canUpdateContent: !!canUpdateContent
        });
    }, [
        contentId,
        canUpdateContent
    ]);
    const toggleDetailsPanel = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        if (panel?.id === 'detailsPanel') hideObjectSidebar();
        else handleClickDetailsButton();
    }, [
        handleClickDetailsButton,
        hideObjectSidebar,
        panel?.id
    ]);
    const openLabelsDialog = (0, $42omo.useCallback)(()=>{
        showModal((0, $4vaoM.EditLabelDialogLoader), {
            contentId: contentId,
            spaceKey: spaceKey,
            source: 'detailsPanelKeyboardShortcut'
        });
    }, [
        showModal,
        contentId,
        spaceKey
    ]);
    const shortcutListeners = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_OPEN_DETAILS_PANEL_SHORTCUT),
        listener: toggleDetailsPanel
    }), isLabelsAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.LABELS_SHORTCUT) : undefined,
        accelerator: (0, $gnkil.UNIVERSAL_LABELS_SHORTCUT),
        listener: canEditLabels ? openLabelsDialog : showNoEditAccessFlag
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.VIEW_ATTACHMENTS_SHORTCUT) : undefined,
        accelerator: (0, $4tOXV.isMac)() ? (0, $gnkil.UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_MAC) : (0, $gnkil.UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_WIN),
        listener: ()=>push((0, $6mKj3.expVal)('cc_attachments_page', 'isEnabled', false) ? (0, $1NBp8.ATTACHMENTS_PAGE).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            }) : `${0, $jlIaF.CONTEXT_PATH}/pages/viewpageattachments.action?pageId=${contentId}`)
    }));
    if (collapsed) return shortcutListeners;
    return (0, $dh538.fg)('confluence_frontend_spotlight_ads_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        onMouseEnter: onHoverDetailsButton,
        "data-vc": "object-sidebar-details-button",
        testId: "object-sidebar-details-button-id"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "left",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $5b43ab3c4bf50adc$var$i18n.showDetailsLabel),
        shortcut: isShortcutTextShown ? openDetailsPanelShortcutStrings : undefined,
        delay: 0,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        onClick: handleClickDetailsButton,
        appearance: "subtle",
        shape: isRovoButtonEnabled ? 'default' : 'circle',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8tSmd))),
        label: formatMessage($5b43ab3c4bf50adc$var$i18n.openDetailsPanelLabel),
        testId: "sidebar-details-button",
        isDisabled: isDisabled && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false),
        interactionName: "details-panel-interaction"
    }), shortcutListeners)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        onMouseEnter: onHoverDetailsButton,
        "data-vc": "object-sidebar-details-button",
        testId: "object-sidebar-details-button-id"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "left",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $5b43ab3c4bf50adc$var$i18n.showDetailsLabel),
        shortcut: isShortcutTextShown ? openDetailsPanelShortcutStrings : undefined,
        delay: 0,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        onClick: handleClickDetailsButton,
        appearance: "subtle",
        shape: isRovoButtonEnabled ? 'default' : 'circle',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8tSmd))),
        label: formatMessage($5b43ab3c4bf50adc$var$i18n.openDetailsPanelLabel),
        testId: "sidebar-details-button",
        isDisabled: isDisabled && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false),
        interactionName: "details-panel-interaction"
    }), shortcutListeners)));
});
module.exports["DetailsPanelButton"] = $5b43ab3c4bf50adc$export$12d2a34da9cda7d;

});

parcelRegister("5qLRP", function(module, exports) {

var $gEtAQ = parcelRequire("gEtAQ");


var $ep3mz = parcelRequire("ep3mz");


var $bMPhU = parcelRequire("bMPhU");


var $1ggpj = parcelRequire("1ggpj");

const $db5b264ea04b1a6b$export$a6d18b072e3b7ccb = {
    ROWS: {
        CUSTOM_CONTENT: 'customContent',
        VIEWS: 'views',
        LENGTH: 'length',
        STATUS: 'status',
        REDACTIONS: 'redactions',
        LABELS: 'labels',
        PERFORMANCE_MODE: 'performanceMode'
    },
    SECTIONS: {
        PROPERTIES: 'properties',
        CONNECTIONS: 'connections'
    }
};
const $db5b264ea04b1a6b$export$e09a3109414746fb = {
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.CUSTOM_CONTENT]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.STATUS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.REDACTIONS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.PERFORMANCE_MODE]: false
};
const $db5b264ea04b1a6b$export$28f9a36e98aa9cf4 = {
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.VIEWS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.LENGTH]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.STATUS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.REDACTIONS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.LABELS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.PERFORMANCE_MODE]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.SECTIONS.CONNECTIONS]: false
};
const $db5b264ea04b1a6b$export$e96bb3f3767bc352 = {
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.VIEWS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.LENGTH]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.STATUS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.REDACTIONS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.LABELS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.PERFORMANCE_MODE]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.SECTIONS.CONNECTIONS]: false
};
const $db5b264ea04b1a6b$export$8221976a966a0540 = {
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.VIEWS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.LENGTH]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.STATUS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.REDACTIONS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.LABELS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.PERFORMANCE_MODE]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.SECTIONS.CONNECTIONS]: false
};
const $db5b264ea04b1a6b$export$6aadc312a449609d = ()=>{
    const isSpaceOverviewViewMode = (0, $gEtAQ.isSpaceOverview)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const homepageId = (0, $bMPhU.useSpaceHomepageId)(spaceKey);
    const isSpaceOverviewEditMode = homepageId === contentId;
    const isSpaceOverviewPage = isSpaceOverviewViewMode || isSpaceOverviewEditMode;
    const getVisibilityConfig = ()=>{
        if (isSpaceOverviewPage) return $db5b264ea04b1a6b$export$e09a3109414746fb;
        if (contentType === (0, $1ggpj.ContentType).DATABASE) return $db5b264ea04b1a6b$export$28f9a36e98aa9cf4;
        if (contentType === (0, $1ggpj.ContentType).WHITEBOARD) return $db5b264ea04b1a6b$export$e96bb3f3767bc352;
        if (contentType === (0, $1ggpj.ContentType).SLIDE) return $db5b264ea04b1a6b$export$8221976a966a0540;
        return null;
    };
    const isElementVisible = (element)=>{
        if (element === $db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.LABELS && (contentType === (0, $1ggpj.ContentType).DATABASE || contentType === (0, $1ggpj.ContentType).WHITEBOARD || contentType === (0, $1ggpj.ContentType).SLIDE)) return true;
        const visibilityConfig = getVisibilityConfig();
        return (visibilityConfig && visibilityConfig[element]) ?? true;
    };
    return {
        isElementVisible: isElementVisible
    };
};
module.exports["ELEMENTS"] = $db5b264ea04b1a6b$export$a6d18b072e3b7ccb;
module.exports["useElementVisibility"] = $db5b264ea04b1a6b$export$6aadc312a449609d;

});

parcelRegister("3l7KO", function(module, exports) {

var $jnFok = parcelRequire("jnFok");


var $eU6eE = parcelRequire("eU6eE");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $a9Ftk = parcelRequire("a9Ftk");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");

const $b684b72ae3cf6eec$var$useContentLabelsDetailsPanelContentLabelsQuery = (0, $eU6eE.default);
const $b684b72ae3cf6eec$var$useContentLabelsDetailsPanelContentLabelDeleteMutation = (0, $jnFok.default);
const $b684b72ae3cf6eec$export$6a1788a7b791cea2 = ()=>{
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)($b684b72ae3cf6eec$var$useContentLabelsDetailsPanelContentLabelsQuery, {
        variables: {
            contentId: contentId
        },
        skip: !contentId,
        __callerPackage__: "@confluence/details-panel"
    });
    const [handleDeleteLabelClick] = (0, $308Wd.useMutationInterop)($b684b72ae3cf6eec$var$useContentLabelsDetailsPanelContentLabelDeleteMutation, {
        __callerPackage__: "@confluence/details-panel"
    });
    const normalizedData = (0, $42omo.useMemo)(()=>(0, $a9Ftk.normalizeContentLabelsData)(data), [
        data
    ]);
    return {
        data: normalizedData,
        handleDeleteLabelClick: handleDeleteLabelClick,
        loading: loading,
        error: error,
        refetch: refetch
    };
};
module.exports["useContentLabels"] = $b684b72ae3cf6eec$export$6a1788a7b791cea2;

});

parcelRegister("jnFok", function(module, exports) {
/**
 * @generated SignedSource<<6b4daeac6b01078ae0fee655b815d094>>
 * @relayHash 44d26cb8c2be158cbd259a7f2611217d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1fae9ece2287d85ec26139ef994bbe298fb53a21bf28bdfcae2767fc4518ec70
const $8021d6b5c22faa05$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "label"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "label",
                            "variableName": "label"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "DeleteLabelPayload",
            "kind": "LinkedField",
            "name": "deleteLabel",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentId"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentLabelsDetailsPanelContentLabelDeleteMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentLabelsDetailsPanelContentLabelDeleteMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "44d26cb8c2be158cbd259a7f2611217d",
            "id": "1fae9ece2287d85ec26139ef994bbe298fb53a21bf28bdfcae2767fc4518ec70",
            "metadata": {},
            "name": "useContentLabelsDetailsPanelContentLabelDeleteMutation",
            "operationKind": "mutation",
            "text": "mutation useContentLabelsDetailsPanelContentLabelDeleteMutation($contentId:ID!,$label:String!){deleteLabel(input:{contentId:$contentId,label:$label}){contentId}}"
        }
    };
}();
$8021d6b5c22faa05$var$node.hash = "12edf2776def05e962614a8adfefefcb";
var $8021d6b5c22faa05$export$2e2bcd8739ae039 = $8021d6b5c22faa05$var$node;
module.exports["default"] = $8021d6b5c22faa05$export$2e2bcd8739ae039;

});

parcelRegister("eU6eE", function(module, exports) {
/**
 * @generated SignedSource<<e1799badeba90cffb181f17f5268282f>>
 * @relayHash 2962e9b615dc30f117ffd42d4a13dc3b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5bbcdac849f6ebb247f335f1b7073ad6dbe3b3e830428c9ba7e793b56954da29
const $83d9841ec036c1b8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                v1 /*: any*/ 
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "orderBy",
                            "value": {
                                "direction": "ASCENDING",
                                "sortField": "LABELLING_CREATIONDATE"
                            }
                        }
                    ],
                    "concreteType": "PaginatedLabelList",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "count"
                        },
                        {
                            "concreteType": "Label",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "label"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "prefix"
                                }
                            ]
                        }
                    ],
                    "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                }
            ]
        },
        {
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "archived",
                        "current",
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentLabelsDetailsPanelContentLabelsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentLabelsDetailsPanelContentLabelsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "2962e9b615dc30f117ffd42d4a13dc3b",
            "id": "5bbcdac849f6ebb247f335f1b7073ad6dbe3b3e830428c9ba7e793b56954da29",
            "metadata": {},
            "name": "useContentLabelsDetailsPanelContentLabelsQuery",
            "operationKind": "query",
            "text": "query useContentLabelsDetailsPanelContentLabelsQuery($contentId:ID!){singleContent(id:$contentId){id,labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){count,nodes{id,label,name,prefix}}},content(id:$contentId,status:[\"archived\",\"current\",\"draft\"]){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$83d9841ec036c1b8$var$node.hash = "d1671015fcb32398ad0bb42e7680ad6d";
var $83d9841ec036c1b8$export$2e2bcd8739ae039 = $83d9841ec036c1b8$var$node;
module.exports["default"] = $83d9841ec036c1b8$export$2e2bcd8739ae039;

});

parcelRegister("a9Ftk", function(module, exports) {
const $02e404c086402fb8$export$1dee72c052fd59a0 = (data)=>{
    const nodes = data?.singleContent?.labels?.nodes;
    const firstNode = data?.content?.nodes?.[0];
    const operations = firstNode?.operations ?? [];
    const type = firstNode?.type;
    const hasEditPermissions = Boolean(operations?.find((item)=>item?.operation === 'update' && item?.targetType === type));
    const labels = nodes?.filter((node)=>node?.name !== 'favourite' || node?.prefix !== 'my') || [];
    return {
        labels: labels,
        hasEditPermissions: hasEditPermissions
    };
};
module.exports["normalizeContentLabelsData"] = $02e404c086402fb8$export$1dee72c052fd59a0;

});

parcelRegister("iCs0a", function(module, exports) {
/**
 * @generated SignedSource<<be7decef20db07d08cac179b2f61a5e6>>
 * @relayHash ceddc8fd35d455d0ec9c8131440c1d1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ba1d88df9c48f9ec78d00fe08fc0d6c6e19c7bc9cedad817a92edcca4b72ef88
const $ee37bd48228c4ad9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "redactionMetadataCount"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentRedactionsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentRedactionsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ceddc8fd35d455d0ec9c8131440c1d1d",
            "id": "ba1d88df9c48f9ec78d00fe08fc0d6c6e19c7bc9cedad817a92edcca4b72ef88",
            "metadata": {},
            "name": "useContentRedactionsQuery",
            "operationKind": "query",
            "text": "query useContentRedactionsQuery($contentId:ID!){singleContent(id:$contentId){id,redactionMetadataCount}}"
        }
    };
}();
$ee37bd48228c4ad9$var$node.hash = "e90ee1af326d42d6929ca80f7d23161b";
var $ee37bd48228c4ad9$export$2e2bcd8739ae039 = $ee37bd48228c4ad9$var$node;
module.exports["default"] = $ee37bd48228c4ad9$export$2e2bcd8739ae039;

});

parcelRegister("hysf6", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $jmjWc = parcelRequire("jmjWc");


const $4119a6166d969e95$var$DetailsPanelHeaderIcon = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "TmpiW",
    name: "DetailsPanelHeaderIcon",
    loader: async ()=>(await (parcelRequire("d40rP"))).DetailsPanelHeaderIcon
});

const $4119a6166d969e95$var$DetailsPanelBody = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "WdQRW",
    name: "DetailsPanelBody",
    loader: async ()=>(await (parcelRequire("4ZTCX"))).DetailsPanelBody
});
const $4119a6166d969e95$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    detailsPanelHeaderLabel: {
        id: "details-panel.panel.header.label",
        defaultMessage: "Details"
    }
});
const $4119a6166d969e95$export$fd546c83bdd1393d = ()=>{
    const { showObjectSidebar: showObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const showDetailsPanel = ({ highlightLabels: highlightLabels } = {})=>{
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).DetailsPanel,
            headerComponentElements: {
                HeaderIcon: $4119a6166d969e95$var$DetailsPanelHeaderIcon,
                headerLabel: $4119a6166d969e95$export$a7357cdd1f0b0168.detailsPanelHeaderLabel
            },
            BodyComponent: $4119a6166d969e95$var$DetailsPanelBody,
            props: {
                highlightLabels: highlightLabels
            }
        }, 'push');
    };
    return {
        isDetailsPanelShown: isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).DetailsPanel,
        showDetailsPanel: showDetailsPanel
    };
};
module.exports["useShowDetailsPanel"] = $4119a6166d969e95$export$fd546c83bdd1393d;

});

parcelRegister("d40rP", function(module, exports) {

let $982bff013bebdbbd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $982bff013bebdbbd$var$load("fJtRR"),
    $982bff013bebdbbd$var$load("9nOeM"),
    $982bff013bebdbbd$var$load("2KQ22"),
    $982bff013bebdbbd$var$load("fth3E"),
    $982bff013bebdbbd$var$load("4Uo9r"),
    $982bff013bebdbbd$var$load("gOkMN"),
    $982bff013bebdbbd$var$load("dtpmo"),
    $982bff013bebdbbd$var$load("jzz75"),
    $982bff013bebdbbd$var$load("jtwfh"),
    $982bff013bebdbbd$var$load("a08Vk"),
    $982bff013bebdbbd$var$load("gctwz"),
    $982bff013bebdbbd$var$load("5uN9h"),
    $982bff013bebdbbd$var$load("l4YAS"),
    $982bff013bebdbbd$var$load("gFEtJ"),
    $982bff013bebdbbd$var$load("gT8XU"),
    $982bff013bebdbbd$var$load("8Rc3a"),
    $982bff013bebdbbd$var$load("Wowvf"),
    $982bff013bebdbbd$var$load("iivLa"),
    $982bff013bebdbbd$var$load("dek7I"),
    $982bff013bebdbbd$var$load("hhss7"),
    $982bff013bebdbbd$var$load("6VoH9"),
    $982bff013bebdbbd$var$load("fNa2t"),
    $982bff013bebdbbd$var$load("7tgvK"),
    $982bff013bebdbbd$var$load("6wr18"),
    $982bff013bebdbbd$var$load("ffEVr"),
    $982bff013bebdbbd$var$load("8zlfy")
]).then(()=>parcelRequire('7N9MO'));

});

parcelRegister("4ZTCX", function(module, exports) {

let $3a3802598c238408$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3a3802598c238408$var$load("fJtRR"),
    $3a3802598c238408$var$load("9nOeM"),
    $3a3802598c238408$var$load("2KQ22"),
    $3a3802598c238408$var$load("fth3E"),
    $3a3802598c238408$var$load("4Uo9r"),
    $3a3802598c238408$var$load("gOkMN"),
    $3a3802598c238408$var$load("dtpmo"),
    $3a3802598c238408$var$load("jzz75"),
    $3a3802598c238408$var$load("jtwfh"),
    $3a3802598c238408$var$load("a08Vk"),
    $3a3802598c238408$var$load("gctwz"),
    $3a3802598c238408$var$load("5uN9h"),
    $3a3802598c238408$var$load("l4YAS"),
    $3a3802598c238408$var$load("gFEtJ"),
    $3a3802598c238408$var$load("gT8XU"),
    $3a3802598c238408$var$load("8Rc3a"),
    $3a3802598c238408$var$load("Wowvf"),
    $3a3802598c238408$var$load("iivLa"),
    $3a3802598c238408$var$load("dek7I"),
    $3a3802598c238408$var$load("hhss7"),
    $3a3802598c238408$var$load("6VoH9"),
    $3a3802598c238408$var$load("fNa2t"),
    $3a3802598c238408$var$load("7tgvK"),
    $3a3802598c238408$var$load("6wr18"),
    $3a3802598c238408$var$load("ffEVr"),
    $3a3802598c238408$var$load("8zlfy")
]).then(()=>parcelRequire('9igqG'));

});

parcelRegister("4vaoM", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $a85e440150ad6165$export$761f49b4caa7a581 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "JXn3W",
    name: "EditLabelDialogLoader",
    loader: async ()=>(await (parcelRequire("dYCq5"))).EditLabelDialogComponent
});
module.exports["EditLabelDialogLoader"] = $a85e440150ad6165$export$761f49b4caa7a581;

});

parcelRegister("dYCq5", function(module, exports) {

let $a2ceae4d27214922$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a2ceae4d27214922$var$load("dUwYW"),
    $a2ceae4d27214922$var$load("jhgNc"),
    $a2ceae4d27214922$var$load("jigcs"),
    $a2ceae4d27214922$var$load("1fnbu")
]).then(()=>parcelRequire('m0wkE'));

});

parcelRegister("3u7PM", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $3cfcff3140a018ad$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    noEditAccessFlagTitle: {
        id: "edit-features.no-edit-access-flag.title",
        defaultMessage: "This shortcut requires edit access"
    },
    noEditAccessFlagDescription: {
        id: "edit-features.no-edit-access-flag.description",
        defaultMessage: "To use this keyboard shortcut, you'll need edit access to this content."
    }
});
const $3cfcff3140a018ad$export$175b3f54640daa25 = (flags)=>{
    const intl = (0, $aXWIB.useIntl)();
    const showNoEditAccessFlag = ()=>{
        flags.showFlag({
            id: 'live-pages-mode-flag',
            title: intl.formatMessage($3cfcff3140a018ad$export$a7357cdd1f0b0168.noEditAccessFlagTitle),
            description: intl.formatMessage($3cfcff3140a018ad$export$a7357cdd1f0b0168.noEditAccessFlagDescription),
            close: 'auto'
        });
    };
    return {
        showNoEditAccessFlag: showNoEditAccessFlag
    };
};
module.exports["useNoEditAccessFlag"] = $3cfcff3140a018ad$export$175b3f54640daa25;

});


//# sourceMappingURL=DetailsPanelButton.44c3382e.js.map
